import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { Box, Button } from '@miro-site/core';
import styled, { css } from 'styled-components';
import animation from '@miro-site/design-tokens/src/foundation/animation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BurgerButton = styled(Button).withConfig({
  displayName: "BurgerMenu__BurgerButton",
  componentId: "sc-9brl1y-0"
})(["", " position:absolute;top:50%;transform:translateY(-50%);.focus-trap{display:block;height:100%;}", ""], function (props) {
  return props.theme.normalizeStyles({
    width: props.theme.header.burger.size,
    height: props.theme.header.burger.size,
    right: props.theme.header.container.horizontalPadding,
    ':focus': _objectSpread({}, props.theme.focus.outlines.withOffset)
  });
}, function (_ref) {
  var $isMobileMenuOpened = _ref.$isMobileMenuOpened;
  return $isMobileMenuOpened && css(["&:hover{", "{", "}}", "{", " &:nth-of-type(1){", "}&:nth-of-type(2){opacity:0;}&:nth-of-type(3){", "}}"], BurgerLine, function (props) {
    return props.theme.normalizeStyles({
      background: props.theme.header.burger.hoverColor
    });
  }, BurgerLine, function (props) {
    return props.theme.normalizeStyles({
      background: props.theme.header.burger.activeColor
    });
  }, function (props) {
    return props.theme.normalizeStyles({
      transform: "rotate(45deg) translateX(5px) translateY(5px)"
    });
  }, function (props) {
    return props.theme.normalizeStyles({
      transform: "rotate(-45deg) translateX(5px) translateY(-5px)"
    });
  });
});
var BurgerButtonLines = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)'
  }
}).withConfig({
  displayName: "BurgerMenu__BurgerButtonLines",
  componentId: "sc-9brl1y-1"
})([""]);
var BurgerLine = styled(Box).attrs({}).withConfig({
  displayName: "BurgerMenu__BurgerLine",
  componentId: "sc-9brl1y-2"
})(["", " width:100%;transition:", ";transition-property:transform,opacity,background,width;&:nth-of-type(1){margin-bottom:5px;}&:nth-of-type(2){margin-bottom:5px;}"], function (props) {
  return props.theme.normalizeStyles({
    background: props.theme.header.burger.color,
    height: props.theme.header.burger.line.height,
    borderRadius: props.theme.header.burger.line.radius
  });
}, animation.transitionDuration);

var BurgerMenu = function BurgerMenu(props) {
  return /*#__PURE__*/_jsx(BurgerButton, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsxs(BurgerButtonLines, {
      children: [/*#__PURE__*/_jsx(BurgerLine, {}), /*#__PURE__*/_jsx(BurgerLine, {}), /*#__PURE__*/_jsx(BurgerLine, {})]
    })
  }));
};

export default BurgerMenu;